// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xF1N","footer":"styles_footer__2K-18"};